// extracted by mini-css-extract-plugin
export default {"tabview":"tabview_fde98d5fbea10f5e16e1"};